const locationOptions = (corporationId) => ({
  httpMethod: 'POST',
  route: 'locations/read',
  generateBody: (searchTerm) => ({
    filters: [
      { field: 'corporation._id', operation: 'equalsID', value: corporationId },
      ...(searchTerm ? [{ field: 'description', operation: 'icontains', value: searchTerm }] : []),
    ],
  }),
});

export default locationOptions;
